import { p as proxyCustomElement, H, h, a as Host } from './index.js';
import { d as defineCustomElement$1 } from './p-C9_XXP_a.js';

const listItemDividerCss = ":host{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;box-sizing:border-box;font-family:Open Sans;font-size:.875rem;font-weight:400;letter-spacing:-.0004em;line-height:1.25rem;line-height:normal;padding:.5rem 0}:host *,:host :after,:host :before{box-sizing:inherit}:host img{flex:none;overflow:hidden;text-overflow:ellipsis;white-space:pre-line}";

const WuiListItemDivider = /*@__PURE__*/ proxyCustomElement(class WuiListItemDivider extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    render() {
        return (h(Host, { key: '3bd4ec1cdf83f3510c1fadfee256e2e7432e15fa' }, h("wui-divider", { key: '83721dea6ea469e24652f1bb510623ce3373e56f' })));
    }
    static get style() { return listItemDividerCss; }
}, [257, "wui-list-item-divider"]);
function defineCustomElement() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["wui-list-item-divider", "wui-divider"];
    components.forEach(tagName => { switch (tagName) {
        case "wui-list-item-divider":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, WuiListItemDivider);
            }
            break;
        case "wui-divider":
            if (!customElements.get(tagName)) {
                defineCustomElement$1();
            }
            break;
    } });
}
defineCustomElement();

export { WuiListItemDivider as W, defineCustomElement as d };
